import React, { useMemo } from 'react';
import { getCountryDataList } from 'countries-list';
import { Input, Select } from '@/components/ui';
import { Form, FormField } from '@/components/business';

export function OrganizationForm ({ form }) {
    const countryOptions = useMemo(
        () => getCountryDataList().map(country => ({ value: country.iso2, label: country.name })),
        []
    );

    return (
        <Form form={form}>
            <FormField name="organizationName" label={i18next.t('organizations.name').toLowerCase()}
                render={({ field }) => <Input {...field} placeholder={i18next.t('organizations.name')} />}
            />
            <FormField name="country" label={i18next.t('common.country')}
                render={({ field }) => (
                    <Select
                        onChange={selectedOption => field.onChange(selectedOption?.value ?? '')}
                        options={countryOptions}
                        placeholder={i18next.t('organizations.select_a_country')}
                        search={10}
                        sort="asc"
                        value={countryOptions.find(option => option.value === field.value) ?? null}
                    />
                )}
            />
        </Form>
    );
}
